  <template id="template-select">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    class="text-left"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :label="label"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
    />
    <!-- preview tab -->
    <b-collapse :class="isPreview ? 'mt-0 mb-3': 'mt-5'" id="collapse-1" v-model="collapse">
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button
            v-if="fieldData.isConditional=='1' && !isPreview"
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-left">
          <b-form-group
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :id="fieldData.id"
            :description="fieldData.helperText[selectedLanguage]"
            :invalid-feedback="fieldData.validationMessage[selectedLanguage]"
          >
            <label>
              <span
                v-if="fieldData.validation &&  JSON.parse(fieldData.validation.required)"
                class="required-span"
              >*</span>
              {{(form1.enableSectionFieldEnumeration == 1 ? (sectionIndex+1)+'.'+(fieldIndex+1) :'')}} {{label ? label : fieldData.label[selectedLanguage]}}
            </label>

            <v-select
              label="name"
              value="value"
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
              :id="fieldData.id"
              :disabled="isDisabled == 1"
              :searchable="fieldData.configuration.isLiveSearchable"
              :clearable="fieldData.configuration.isClearable"
              :multiple="fieldData.configuration.isMultipleSelect"
              :options="renderOptions"
              v-model="selected"
              @input="checkCondition"
            />
            <label
              v-if="fieldData.validation && fieldData.validation.required == 1 && !selected && isFocus"
              :class="$store.state.rightAlign ? 'text-right text-danger' : 'text-left text-danger'"
            >{{fieldData.validationMessage[selectedLanguage]}}</label>
          </b-form-group>

          <!-- conditional input field -->
          <b-collapse v-model="showCollapseField" class="mt-2">
            <!-- v-show="conditionalFieldIsVisible == 1" -->
            <b-form-group
              :class="$store.state.rightAlign ? 'text-right ml-3' : 'text-left ml-3'"
              :description="fieldData.conditionalFieldHelperText[selectedLanguage]"
              :label="fieldData.conditionalFieldLabel[selectedLanguage]"
              :invalid-feedback="msg.xss ? $t('createProfile.invalidInputMessage') : $t('createProfile.requiredValidationMessage')"
            >
              <b-form-textarea
                :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
                v-model="conditionalFieldInputValue"
                @input="onInputType"
                :disabled="isDisabled == 1"
                :placeholder="fieldData.conditionalFieldPlaceHolderText[selectedLanguage]"
                :rows="fieldData.conditionalFieldMinRows || 3"
                :max-rows="fieldData.conditionalFieldMaxRows || 6"
                :state="msg.xss ? false : (isFocus && conditionalFieldInputValue && isMatchCondition && fieldData.validation.required == 1 ? true : false)"
                @focus="isFocus=true"
              ></b-form-textarea>
            </b-form-group>
          </b-collapse>
        </b-col>
      </b-row>
      <!-- advance settings tab -->

      <b-modal
        cancel-title="Close"
        ok-title="Save"
        @ok="onSaveData"
        size="lg"
        v-model="showSettings"
        @hidden="onUpdateSettings"
        title="Select Picker Advanced Settings"
      >
        <AdvanceSelectSettings
          v-if="showSettings"
          :fieldData="fieldData"
          v-on:toggle-field="showSettings=!showSettings"
          v-on:update-form-settings="getData"
          @label-text="label = $event"
          @helper-text="helperText = $event"
          :sectionIndex="sectionIndex"
        />
      </b-modal>
    </b-collapse>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
//import VSelect from "@alfsnd/vue-bootstrap-select";
import vSelect from "vue-select";
import MenuButtons from "../menuButtons";
import AdvanceSelectSettings from "../advanceRadioSettingsComponent";
import { mapGetters, mapMutations, mapState } from "vuex";
import { EventBus } from "@/event-bus.js";
import { Validate } from "../../helpers";
import _ from "lodash";

export default {
  name: "SelectGroup",
  components: {
    MenuButtons,
    AdvanceSelectSettings,
    vSelect,
  },
  data() {
    return {
      isHidden: false,
      isFocus: false,
      condition: {},
      showSettings: false,
      collapse: true,
      label: undefined,
      helperText: undefined,
      isRequired: 1,
      name: "",
      renderOptions: [],
      selected: this.fieldData.selected || null,
      conditionalFieldLabel: null,
      conditionalFieldHelperText: null,
      conditionalFieldPlaceHolderText: null,
      conditionalFieldValidationMessage: null,
      conditionalFieldIsRequired: 0,
      conditionalFieldMaxRows: 1,
      conditionalFieldInputValue: null,
      conditionalFieldPostName: null,
      conditionalFieldIsVisible: 0,
      showCollapseField: false,
      isMatchCondition: false,
      msg: {},
    };
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage", "userFormSubmitArray"]),
    ...mapState(["toggleAllCoppalse"]),
  },
  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (this.hasActiveXssError()) {
        this.$store.state.validFields = false;
        this.fieldData.isInValid = true;
        return;
      }
      if (value == "progress") {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      } else {
        if (
          this.fieldData.validation &&
          this.fieldData.validation.required == 1
        ) {
          if (!this.selected) {
            this.isFocus = true;
            this.$store.state.validFields = false;
            this.fieldData.isInValid = true;
          } else if (this.selected) {
            if (this.isMatchCondition) {
              if (!this.conditionalFieldInputValue) {
                this.isFocus = true;
                this.$store.state.validFields = false;
                this.fieldData.isInValid = true;
              } else {
                this.$store.state.validFields = true;
                this.fieldData.isInValid = false;
              }
            }
          } else {
            this.$store.state.validFields = true;
            this.fieldData.isInValid = false;
          }
        }
      }
    });


      EventBus.$on("OnInvalidFieldCatch", inValidData => {
      // console.log("OnInvalidFieldCatch radio", inValidData, this.fieldData.id)
      document.getElementById(inValidData.elementId).scrollIntoView({ behavior: "smooth" });

    });
  },
  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    },
  },
  mounted() {
    
    this.isRequired = this.fieldData.validation.required;
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      this.setFieldValue();
      this.setConditionInput();
    }

    let getOptions = this.fieldData.options;
    getOptions.map((option) => {
      Object.assign( option, { name:  option.text[this.selectedLanguage] || "No Value Set"} );
      this.renderOptions.push(option);
    });
    this.conditionalFieldIsVisible = this.fieldData.conditionalFieldIsVisible;
  },
  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),
    getData(data) {
      this.$emit("update-form-settings", data);
    },
    onUpdateSettings() {
      this.TOGGLE_LOADER(2);
    },

    checkCondition(value) {
      this.isFocus = false;
      this.$store.state.validFields = true;
      this.fieldData.isInValid = false;

      let elements = this.form1.formSection[this.sectionIndex].formElements;
      let found = elements.find((ff, index) => {
        if (ff.conditions && ff.conditions.length) {
          ff.conditions.map(aa => {
            if (aa.sourceFieldId === this.fieldData.id && aa.value === value) {
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = false;
            } else {
              this.form1.formSection[this.sectionIndex].formElements[
                index
              ].isHidden = true;
            }
          });
        } else {
          this.form1.formSection[this.sectionIndex].formElements[
            index
          ].isHidden = false;
        }
      });

      // for new conditional fields..
      if (
        this.fieldData.selectedConditionalFieldValue &&
        this.fieldData.selectedConditionalFieldValue == value
      ) {
        this.showCollapseField = true;
        this.conditionalFieldIsVisible = 1;
        this.isMatchCondition = true;
      } else {
        this.showCollapseField = false;
        this.conditionalFieldIsVisible = 0;
        this.clearProgressiveInputData();
        this.conditionalFieldInputValue = null;
        this.fieldData.conditionalFieldInputValue = null;
        this.fieldData.conditionalFieldIsVisible = false;
        this.msg = {};
        this.isMatchCondition = false;
      }
      this.setValue(value);
    },

    setConditionInput() {
      if (
        this.fieldData.selectedConditionalFieldValue &&
        this.fieldData.selectedConditionalFieldValue == this.selected
      ) {
        // if(this.fieldData.conditionalShowHiddenOption == 1){
        this.showCollapseField = true;
        this.conditionalFieldIsVisible = 1;
        this.isMatchCondition = true;
        this.isFocus = true;

        // }
      } else {
        this.showCollapseField = false;
        this.conditionalFieldIsVisible = 0;
        this.isMatchCondition = true;
        this.isFocus = false;
      }
    },

    setFieldValue() {
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            a.elements.map((el) => {
              el.postValue.map((value) => {
                value.name = value.text[this.selectedLanguage];
              });
              if (el.key == "select") {
                this.selected = el.postValue;
              } else if (el.key == "progressive") {
                this.conditionalFieldInputValue = el.postValue;
              }
            });
          }
        });
      if (this.selected) {
        this.initialCheckCondition(this.selected);
      }
    },

    initialCheckCondition(value) {
      if (value && value.length) {
        this.selected.map((chk) => {
          let condOptions = undefined,
            selectedConditionalFieldValue =
              this.fieldData.selectedConditionalFieldValue;

          if (
            chk &&
            selectedConditionalFieldValue &&
            typeof selectedConditionalFieldValue == "string"
          ) {
            condOptions = _.isEqual(selectedConditionalFieldValue, chk.value);
          } else if (
            chk &&
            selectedConditionalFieldValue &&
            typeof selectedConditionalFieldValue == "object" &&
            selectedConditionalFieldValue.length
          ) {
            for (let opt of selectedConditionalFieldValue) {
              condOptions = _.isEqual(opt.value, chk.value);
              if (condOptions) {
                break;
              }
            }
          }
          if (condOptions) {
            this.showCollapseField = true;
            this.conditionalFieldIsVisible = 1;
            this.isMatchCondition = true;
            this.isFocus = true;
          } else {
            this.showCollapseField = false;
            this.conditionalFieldIsVisible = 0;
            this.conditionalFieldInputValue = null;
            this.fieldData.conditionalFieldInputValue = null;
            this.fieldData.conditionalFieldIsVisible = false;
            this.msg = {};
            this.isMatchCondition = false;
            this.isFocus = true;
          }
        });
      }
    },

    setValue(e) {
      const registerData = _.clone(this.$store.state.registerData);

      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        this.selected = e;
        if (e && e.length > 0 && !this.conditionalFieldIsVisible) {
          this.conditionalFieldInputValue = null;
          this.fieldData.conditionalFieldInputValue = null;
          this.msg = {};
          this.clearProgressiveInputData();
          registerData[this.fieldData.id] = e;
        } else {
          delete registerData[this.fieldData.id];
        }
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
        this.$store.state.progressValue = numkeys;

        if (
          this.fieldData.configuration &&
          this.fieldData.configuration.isMultipleSelect &&
          this.selected.length
        ) {
          this.userFormSubmitArray.find((a, index) => {
            if (a.elementId === this.fieldData.id) {
              a.elements[0] = {
                postValue: this.selected,
                key: "select",
                postName:
                  (this.fieldData.attributes &&
                    this.fieldData.attributes.postName) ||
                  "postNameSelect",
              };
            }
          });
        }
        // this.fieldData.selected = this.selected;
        else if (this.selected) {
          let aa = [];
          aa.push(this.selected);
          this.userFormSubmitArray.find((a, index) => {
            if (a.elementId === this.fieldData.id) {
              a.elements[0] = {
                postValue: aa,
                key: "select",
                postName:
                  (this.fieldData.attributes &&
                    this.fieldData.attributes.postName) ||
                  "postNameSelect",
              };
            }
          });
        }
      }
    },

    checkXss(value) {
      if (!Validate.noXSS(value)) {
        this.msg["xss"] = true;
        return true;
      }
      this.msg["xss"] = false;
      return false;
    },

    hasActiveXssError() {
      return Object.keys(this.msg).some((key) => key.startsWith("xss") && this.msg[key]);
    },

    onInputType(e) {
      const hasXss = this.checkXss(e);
      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        (this.$route.name == "ViewComplaints" && this.showCollapseField)
      ) {
        if (!hasXss) {
          this.$store.state.userFormSubmitArray.map((a, index) => {
            if (a.elementId === this.fieldData.id) {
              a.elements[1] = {
                postValue: e,
                key: "progressive",
                postNameProgressive:
                  this.fieldData.conditionalFieldLabel || "postNameProgressive",
              };
            }
          });
        }
      }
    },

    clearProgressiveInputData() {
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a) => {
          if (a && a.elementId && a.elements && a.elements.length) {
            if (a.elementId === this.fieldData.id) {
              a.elements.splice(1, 1);
            }
          }
        });
      this.$store.state.userFormSubmitArray.length &&
        this.$store.state.userFormSubmitArray.map((a) => {
          if (a && a.elementId && a.elements && a.elements.length) {
            if (a.elementId === this.fieldData.id) {
              a.elements.splice(1, 1);
            }
          }
        });
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
    },
  },

  validations: {
    selected: {
      required,
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style>
.v-select.disabled .v-select-toggle[data-v-138dff1d] {
  background-color: white !important;
}
.vs__dropdown-menu {
    overflow-y: scroll;
    height: 150px;
}
</style>

